/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Coaching_Last_WorkoutInputs */

const en_us2_coaching_last_workout = /** @type {(inputs: Coaching_Last_WorkoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last workout ${i?.when}`)
};

const pt_br2_coaching_last_workout = /** @type {(inputs: Coaching_Last_WorkoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último treino ${i?.when}`)
};

const pt_pt2_coaching_last_workout = /** @type {(inputs: Coaching_Last_WorkoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Último treino ${i?.when}`)
};

/** @type {(inputs: Coaching_Last_WorkoutInputs) => LocalizedString} */
const es_419_coaching_last_workout = en_us2_coaching_last_workout;

/** @type {(inputs: Coaching_Last_WorkoutInputs) => LocalizedString} */
const fr_fr2_coaching_last_workout = en_us2_coaching_last_workout;

/** @type {(inputs: Coaching_Last_WorkoutInputs) => LocalizedString} */
const de_de2_coaching_last_workout = en_us2_coaching_last_workout;

/** @type {(inputs: Coaching_Last_WorkoutInputs) => LocalizedString} */
const it_it2_coaching_last_workout = en_us2_coaching_last_workout;

/**
* | output |
* | --- |
* | "Last workout {when}" |
*
* @param {Coaching_Last_WorkoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_last_workout = /** @type {((inputs: Coaching_Last_WorkoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Last_WorkoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_last_workout(inputs)
	if (locale === "es-419") return es_419_coaching_last_workout(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_last_workout(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_last_workout(inputs)
	if (locale === "de-DE") return de_de2_coaching_last_workout(inputs)
	if (locale === "it-IT") return it_it2_coaching_last_workout(inputs)
	return en_us2_coaching_last_workout(inputs)
});
export { coaching_last_workout as "coaching.last_workout" }